import { throwError } from "@/lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import {
  StateMaster,
  StateMasterList,
  StatePayload,
} from "@/utils/types/stateMasters";

const basePath = "/api/workflow/state-masters";

class WorkflowStateService {
  getAllStateMasters = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }): Promise<StateMasterList> => {
    return await get<StateMasterList>(`${basePath}/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getStateMasterById = async (id: string): Promise<StateMaster> => {
    if (!id) {
      throwError("ID is required", "WorkflowStateService");
    }
    return await get<StateMaster>(`${basePath}/${id}/`);
  };

  createStateMaster = async (payload: StatePayload): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "WorkflowStateService");
    }
    return await post(`${basePath}/`, payload);
  };

  updateStateMaster = async (
    id: string,
    payload: StatePayload
  ): Promise<any> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "WorkflowStateService");
    }
    return await put(`${basePath}/${id}/`, payload);
  };

  deleteStateMaster = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "WorkflowStateService");
    }
    return await del(`${basePath}/${id}/`);
  };
}

const instance = new WorkflowStateService();
export default instance;
